// Client-side mirror of backend `MILESTONE_LADDER` in `routes_projects.py`.
// Keep these in sync — copy must match exactly. The backend remains the source
// of truth for *what* milestone the user has crossed (returned as
// `pending_milestone`); this map is only used when we need the persistent
// inline-encouragement copy on the steps tab, derived from `milestones_shown`
// + `progress_pct` already in the project payload.
export const MILESTONE_COPY = {
  first_step: {
    headline: "Nice start.",
    sub: "Most projects never make it this far. This one did.",
  },
  p25: {
    headline: "You're underway.",
    sub: "A lot of projects never get past the planning stage. You're already ahead.",
  },
  p50: {
    headline: "That's more than Half Job done.",
    sub: "You're officially past the point where most people would leave the tools sitting in the garage for six months.",
  },
  p75: {
    headline: "You've entered the classic DIY phase.",
    sub: "\"I'll finish that next weekend.\" Let's not do that.",
  },
  p90: {
    headline: "You can almost taste it.",
    sub: "One last push before this becomes an \"I'll get around to it one day\" project.",
  },
  p100: {
    headline: "Project complete.",
    sub: "You're now legally required to point at it and say: \"Yep. I did that.\"",
  },
};

// Ordered low-to-high. Used by the inline encouragement card to pick the
// highest milestone the user has crossed.
export const MILESTONE_ORDER = ["first_step", "p25", "p50", "p75", "p90", "p100"];

// Given progress + step count, return the highest milestone key crossed
// (regardless of whether it's been "shown"/dismissed). Returns null if none.
export function highestEarnedMilestone({ progressPct = 0, stepsDone = 0 }) {
  const earned = [];
  if (stepsDone >= 1) earned.push("first_step");
  if (progressPct >= 25) earned.push("p25");
  if (progressPct >= 50) earned.push("p50");
  if (progressPct >= 75) earned.push("p75");
  if (progressPct >= 90) earned.push("p90");
  if (progressPct >= 100) earned.push("p100");
  if (!earned.length) return null;
  // Highest by ladder order.
  return earned[earned.length - 1];
}

// Milestones that are "signature" Half Job moments and deserve the bigger
// celebration treatment (per spec).
export const SIGNATURE_MILESTONES = new Set(["p50", "p100"]);
